import { Adapter } from "@app/shared/models/adapter.model";

interface Security {
  canMultiTab: boolean;
  canFavorite: boolean;
  isLocked: boolean;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canView: boolean;
  canReport: boolean;
  isFavorite: boolean;
}

export interface Application {
  id: string;
  url: string;
  shortDescription: string;
  longDescription: string;
  modules: MenuModule[];
}

export interface MenuModule {
  id: string;
  shortDescription: string;
  longDescription: string;
  groups: MenuGroup[];
  application: string;
}

export interface MenuGroup {
  id: string;
  shortDescription: string;
  longDescription: string;
  items: MenuOption[];
}

export interface MenuOption {
  id: string;
  componentId?: string; // ComponentId (typically component name) used for screen maintenance reference and how to load lazily loaded component
  itemDescription?: MenuDescriptions;
  object?: string;
  isLegacy?: boolean;
  security?: Security;
  application?: string;
  applicationDescription?: MenuDescriptions;
  applicationUrl?: string;
  module?: string;
  moduleDescription?: MenuDescriptions;
  group?: string;
  groupDescription?: MenuDescriptions;
  icon?: string;
  component?: any; // component reference to use to render content
  roleId?: string; // roleId for menu option
}

export interface MenuId {
  menuId: string;
}

export interface MenuOptionId {
  id: string;
}

export interface MenuAccess {
  menuId: string;
  hasAccess: boolean;
  roleId?: string;
}
export interface MenuDescriptions {
  shortDescription: string;
  longDescription?: string;
}

export interface LockedMenuMessage {
  id: string;
  message: string;
}

export interface UserMenuItem {
  menuItem: string;
  menuSequence?: number;
  application?: Application;
}

export class MenuAdapter implements Adapter<Application[]> {
  adapt(rawData: any) {
    return rawData.applications;
  }
}

export class MenuAccessAdapter implements Adapter<MenuAccess> {
  adapt(rawData: MenuAccess) {
    return rawData;
  }
}

export class LockedMenuMessageAdapter implements Adapter<LockedMenuMessage> {
  adapt(rawData: LockedMenuMessage) {
    return rawData;
  }
}
export class UserMenuItemRequestAdapter implements Adapter<any> {
  adapt(rawData: UserMenuItem[]) {
    const menuItems = JSON.parse(JSON.stringify(rawData)).map((x) => {
      x.application = null;
      return x;
    });
    return { dashboardItems: menuItems };
  }
}
export class UserMenuItemResponseAdapter implements Adapter<UserMenuItem[]> {
  adapt(rawData: any) {
    return rawData.dashboardItems;
  }
}
